import { useContext, useEffect } from "react";
import { SearchVehicleByVinDataContext } from "../SearchVehicleByVinDataProvider";
import { LoadingData, LoadingDataRequestsType, SearchVehicleDataContextType, SetSearchVehicleDataContextType } from "../types";
import { carByVinRequest } from "../../../../utils/requests/laximo/carByVinRequest";

/** Загрузка автомобиля по VIN */
export const LoadVehicleByVin = ({ children }: { children: React.ReactNode }) => {
    const { vin, setSearchVehicle, setIsLoading, setError, findVehicle } = useContext(SearchVehicleByVinDataContext) as SearchVehicleDataContextType & SetSearchVehicleDataContextType & LoadingData & LoadingDataRequestsType;

    useEffect(() => {
        if (vin) {
            setIsLoading(true);
            carByVinRequest(vin)
                .then(data => {
                    setSearchVehicle(data);
                    findVehicle(data.vehicle);
                })
                .catch(error => {
                    setError(error.message);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [vin]);

    return children;
};